import { Box, Card, CardContent, Typography } from "@mui/material";
import { FC } from "react";
import { figureFormatter } from "../../../utils/figure_formatter";
import { getName } from "../../Clients/models/ColumnShape";
import StatusBtn from "../../../components/UI/StatusBtn";
import { useNavigate } from "react-router-dom";
import { Span } from "../../../components/Typography";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

interface IDetailsInfo {
  entityDetails: any;
}

const LoanDisbursement: FC<IDetailsInfo> = ({ entityDetails }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardContent>
        <Typography
          sx={{
            fontSize: 14,
            mb: 1.5,
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          gutterBottom
        >
          Loan Details
          <Box
            sx={{ display: "inline-block" }}
            onClick={() => {
              navigate(`/loans/loan-details/${entityDetails?.id}`);
            }}
          >
            <StatusBtn
              type={1}
              title={
                <Span display={"inline-flex"} padding={0.5} gap={1}>
                  More <ArrowOutwardIcon fontSize={"small"} color="primary" />
                </Span>
              }
            />
          </Box>
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Loan No:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {entityDetails?.loan_no}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Branch:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {entityDetails?.branch?.name}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Client:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {getName(
            entityDetails?.account_details?.client_details?.user_details,
            entityDetails?.account_details?.client_details?.client_type,
          )}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Principal:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {figureFormatter({
            figure: entityDetails?.principal,
            currency: entityDetails?.currency?.currency || "",
          })}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Interest:
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {figureFormatter({
            figure: entityDetails?.interest_amount,
            currency: entityDetails?.currency?.currency || "",
          })}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Loan Officer
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {`${entityDetails?.loan_officer?.first_name || ""} ${
            entityDetails?.loan_officer?.last_name || ""
          }`}
        </Typography>

        <Typography
          sx={{ fontSize: 14, mb: 1.5 }}
          color="text.disabled"
          gutterBottom
        >
          Comment
        </Typography>
        <Typography sx={{ fontSize: 14, mb: 1.5 }} gutterBottom>
          {entityDetails?.notes}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default LoanDisbursement;
